// export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const END_POINT = {
   BASE_URL: `${process.env.REACT_APP_BASE_URL}/api`,
   AUTH_URL: `${process.env.REACT_APP_BASE_URL}/api`,
   BASE: process.env.REACT_APP_BASE_URL,
   CLIENT_ID: process.env.CLIENT_ID,
   GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
}

export const appName = "Arno";